import React from 'react'

function FeatureBlock(props) {
    return (
        <div className="group grid grid-cols-1 md:grid-cols-2 gap-y-6 md:gap-y-0 gap-x-12 py-8 items-center">
            <div className="overflow-hidden rounded-2xl shadow-lg transition-all duration-300 group-hover:shadow-xl group-hover:scale-[1.01]">
                <img className='w-full h-full object-cover' style={{ aspectRatio: '4/3' }} src={props.img} alt="" />
            </div>
            <div className='text-start max-w-lg'>
                <h3 className='text-2xl sm:text-3xl font-bold mb-4 text-gray-900'>{props.title}</h3>
                <p className='text-base leading-7 text-gray-600'>
                    {props.text}
                </p>
                <div className='mt-8'>
                    <a
                        href={props.link}
                        className="inline-flex items-center rounded-xl bg-gray-900 px-6 py-3 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-brand-600 hover:scale-[1.02]"
                    >
                        {props.button}<span className="ml-2" aria-hidden="true">&rarr;</span>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default FeatureBlock
